var React = require('react');

function FullscreenInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"#FFF","strokeWidth":"2"},[React.createElement("path",{"d":"M0 6.667L0 0 6.667 0","transform":"translate(1 1)","key":0}),React.createElement("g",{"key":1},[React.createElement("g",{"key":0},[React.createElement("path",{"d":"M0 6.667L0 0 6.667 0","transform":"translate(1 1) rotate(-180 10 10)","key":0}),React.createElement("path",{"d":"M13.333 6.667L13.333 0 20 0","transform":"translate(1 1) rotate(-180 10 10) rotate(90 16.667 3.333)","key":1})]),React.createElement("path",{"d":"M13.333 6.667L13.333 0 20 0","transform":"translate(1 1) rotate(90 16.667 3.333)","key":1})])]));
}

FullscreenInline.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22"};

module.exports = FullscreenInline;

FullscreenInline.default = FullscreenInline;
